import classNames from 'classnames';

import DeliveryIcon from '@svg/delivery.svg';

import s from './SmartIcon.sss';

interface Props {
  className?: string,
  size: '72' | '40' | '56' | '32' | '24' | '18'
}

export const SmartIcon: React.FC<Props> = ({
  className,
  size = '24',
}) => (
  <span
    className={classNames(s.root, className, {
      [s.rootSize72]: size === '72',
      [s.rootSize56]: size === '56',
      [s.rootSize40]: size === '40',
      [s.rootSize32]: size === '32',
      [s.rootSize24]: size === '24',
      [s.rootSize18]: size === '18',
    })}
  >
    <DeliveryIcon className={s.icon} />
  </span>
);
